import { fun_PostAction, fun_Download } from "@/api";
import CaLock from "@/components/common/calock";
import { fun_DownloadFile } from "@/utils/validate";

// 导出
export default {
  // 数据存储
  data: () => {
    // 返回
    return {
      // 默认关闭弹窗
      dialogVisible: false,
      // 主键
      id: null,
      // 各种编号
      everyIds: null,
      // ids
      data: null,
      // 权限编号
      operationNum: null,
      // 招标代理备案表主键
      agencyId: null,
      // 默认不显示
      isShow: false,
      // 标志
      flag: false,
      // pdf路径
      pdfUrl: null,
      // 是否显示加盖签章按钮
      showBtn: true
    };
  },
  
  // 注册组件
  components: {
    CaLock, // CA锁
  },
  // 自定义方法
  methods: {
    /**
     * 点击盖章的事件
     */
    fun_InsertStamp() {
      // 开启弹窗
      this.$refs.caLock.dialogCalock = true;
      // 签名数据
      this.$refs.caLock.data = this.data;
      // 状态
      this.$refs.caLock.state = "tj";
      // 类型
      this.$refs.caLock.pageType = "seal";
    },
    /**
     * 请求盖章图片
     * @param {*} state 状态
     * @param {*} lockNo 所编号
     * @param {*} digitalSignature
     * @param {*} type 签名类型 ca-ca,app-扫码
     * @param {*} token
     */
    fun_SaveOrUpdate(state, lockNo, digitalSignature, type) {
      // 关闭弹窗
      this.$refs.caLock.dialogCalock = false;
      // 传递参数
      let pa = {
        id: this.id,
        everyIds: this.everyIds,
        operationNum: this.operationNum,
        lockNo: lockNo
      };
      // 请求盖章图片
      fun_PostAction("/printForCheck", pa).then(res => {
        // 请求参数
        const { data, result, msg } = res.data;
        // 请求成功
        if (result) {
          this.$parent.fun_DialogPrint(this.data, data.agencyLock, data.tenderLock, data.agencyRecords, data.bidderLock, lockNo, data.recordNumber, this.flag);
        } else {
          // 提示信息
          this.$message.error(msg);
        }
      });
    },
    /**
     * 不加盖签章的办法
     * @author shuhua
     */
    fun_NoLock() {
      this.$parent.fun_DialogPrint(this.id, '', '','','','','', this.flag);
    },
    /**
     * 弹窗关闭的事件
     * @author shuhua
     */
    fun_HandleClose() {
      // 重置值
      this.isShow = false;
      // pdf路径
      this.pdfUrl = null;
    }
  }
};
